export const prepareHtmlWithAnchoredHeadings = (html: string) => {
  const parser = new DOMParser();

  const doc = parser.parseFromString(html, 'text/html');

  const anchoredHeadingElements = doc.querySelectorAll(
    'h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]',
  );

  for (const heading of anchoredHeadingElements) {
    if (!heading.hasAttribute('id')) {
      continue;
    }

    const buttonElement = doc.createElement('button');
    buttonElement.setAttribute('data-anchored', 'true');
    buttonElement.innerHTML = heading.innerHTML;

    heading.innerHTML = ''; // Clear the heading element content which is now in the button
    heading.appendChild(buttonElement);
  }

  return doc.body.innerHTML;
};
